import { Text } from "components/Text"
import { useTranslator } from "components/Translator"
import { useBreakpoints } from "hooks/useBreakpoints"
import { RawLink } from "components/Link"
import { ProductCard } from "domains/product/ProductCard"

export const RelatedProducts = ({ products }) => {
  const translator = useTranslator()
  const { lg } = useBreakpoints()

  const items = products.map((product) => {
    return (
      <div key={product.id} className="shrink-0 w-52 lg:w-auto">
        <RawLink
          href={{
            route: "app_club_shop_product_show",
            params: { productId: product.id },
          }}
          external
          title={product.title}
        >
          <ProductCard product={product} />
        </RawLink>
      </div>
    )
  })

  return (
    <section className="space-y-6">
      <Text variant="headline3" tag="h2">
        {translator.trans(
          "club.product.show.relatedProducts.title",
          null,
          "pages",
        )}
      </Text>
      {lg ? (
        <div className="grid grid-cols-4 gap-4">{items}</div>
      ) : (
        <div className="px-5 pb-2 flex space-x-6 overflow-x-auto">{items}</div>
      )}
    </section>
  )
}
